import configuracionService from '../services/configuracionService';
import type {
  GranjaArticuloClasificacion,
  GranjaConfig,
  GranjaLoteConfig,
} from '../services/granjaService';

export const GRANJA_SECCION = 'GRANJA';

async function upsert(campo: string, valor: string, comentario?: string): Promise<void> {
  const existing = await configuracionService.getByKey(GRANJA_SECCION, campo, '');
  const dto = {
    usuario: '',
    seccion: GRANJA_SECCION,
    campo,
    valor,
    comentario: comentario ?? existing?.comentario ?? null,
  };
  if (existing) {
    await configuracionService.updateConfiguracion(dto);
  } else {
    await configuracionService.createConfiguracion(dto);
  }
}

export async function saveGranjaConfig(config: GranjaConfig): Promise<void> {
  await upsert(
    'DEPOSITO_GRANJA',
    config.depositoGranja != null ? String(config.depositoGranja) : '',
    'Nro ubicación depósito Granja',
  );
  await upsert(
    'ARTICULO_CASCADO',
    config.articuloCascado ?? '',
    'Código artículo huevo cascado/roto/sucio',
  );
  await upsert(
    'RECETA_MIXER_DEFAULT',
    config.recetaMixerDefault ?? '',
    'Código receta mixer por defecto',
  );
  await upsert(
    'BATCH_KG_DEFAULT',
    config.batchKgDefault != null ? String(config.batchKgDefault) : '',
    'Kg por batch mixer por defecto',
  );

  const arts: GranjaArticuloClasificacion[] = config.articulosClasificacion ?? [];
  await upsert(
    'ARTICULOS_CLASIFICACION',
    JSON.stringify(arts),
    'JSON calibres/colores → código artículo',
  );

  const existing = await configuracionService.listAll({ seccion: GRANJA_SECCION, usuario: '' });
  const loteCampos = existing
    .map((c) => c.campo)
    .filter((c) => c.toUpperCase().startsWith('LOTE_'));

  const lotes: GranjaLoteConfig[] = config.lotes ?? [];
  const keep = new Set(lotes.map((l) => `LOTE_${l.codigo}`.toUpperCase()));

  for (const campo of loteCampos) {
    if (!keep.has(campo.toUpperCase())) {
      await upsert(campo, '', 'Lote eliminado');
    }
  }

  for (const lote of lotes) {
    const campo = `LOTE_${lote.codigo}`;
    const payload = {
      codigo: lote.codigo,
      articuloAves: lote.articuloAves,
      articuloHuevoBruto: lote.articuloHuevoBruto,
      fechaIngreso: lote.fechaIngreso ?? null,
      cabezasIniciales: lote.cabezasIniciales,
      toleranciaPct: lote.toleranciaPct,
      activo: lote.activo,
    };
    await upsert(campo, JSON.stringify(payload), `Lote aves ${lote.codigo}`);
  }
}
